const platforms = [
  {
    key: 'youtube',
    text: 'YouTube',
    value: 'youtube',
    image: '/icons/youtube.svg',
  },
  {
    key: 'instgram',
    text: 'Instagram',
    value: 'instagram',
    image: '/icons/instagram.svg',
  },
  {
    key: 'twitter',
    text: 'Twitter',
    value: 'twitter',
    image: '/icons/twitter.svg',
  },
  {
    key: 'facebook',
    text: 'Facebook',
    value: 'facebook',
    image: '/icons/facebook.svg',
  },
  {
    key: 'twitch',
    text: 'Twitch',
    value: 'twitch',
    image: '/icons/twitch.svg',
  },
  {
    key: 'tiktok',
    text: 'Tiktok',
    value: 'tiktok',
    image: '/icons/tiktok.svg',
  },
  {
    key: 'shopify',
    text: 'Shopify',
    value: 'shopify',
    image: '/icons/shopify.svg',
  },
];

export default platforms;



/** WEBPACK FOOTER **
 ** ./src/utils/helpers/platforms.js
 **/